import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index59.css';const header = "_header_1p7qk_1";
const content = "_content_1p7qk_9";
const showBorder = "_showBorder_1p7qk_22";
const s = {
  header,
  content,
  showBorder
};
const Header = forwardRef(({ showBorder: showBorder2, children, className, ...restHtmlProps }, ref) => {
  if (!children) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: clsx(s.header, className), ...restHtmlProps, ref, children: /* @__PURE__ */ jsx("span", { className: clsx(s.content, { [s.showBorder]: showBorder2 }), children }) });
});
Header.displayName = "section-header";
export {
  Header
};
